import React, { useEffect } from "react";
import AppLoader from "../../assets/images/appLoader.gif";

const cognitoLoginUrl = process.env.REACT_APP_COGNITO_LOGIN_URL;
const Login = () => {
  const handleLogin = () => {
    if (cognitoLoginUrl) {
      window.location.href = cognitoLoginUrl;
    } else {
      console.error("Cognito login URL is not defined");
    }
  };
  useEffect(() => {
    handleLogin();
  }, []);
  return <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img src={AppLoader} alt="Loading website definition" width={130} />
    </div>;
};

export default Login;
